import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import main from './views/main.vue'
import page1 from './views/shop_list.vue'
import page2 from './views/room_list.vue'
import deploy_play from './views/navigation_common_deploy/deploy_play.vue'
import login from './views/Login'
import order_system from './views/order_system.vue'
import banner_system from './views/banner_system.vue'
import user_personal from './views/user_personal.vue'
import user_system from './views/system_components/user_system.vue'
import job_system from './views/system_components/job_system.vue'
import department_system from './views/system_components/department_system.vue'
import activity_system from './views/activity_components/activity_system.vue'
import coupon_system from './views/activity_components/coupon_system.vue'
import coupon_type_system from './views/activity_components/coupon_type_system.vue'
import feedback_system from './views/feedback_system.vue'
import settled_system from './views/settled_system.vue'
import faq_system from './views/faq_system.vue'
import message_system from './views/message_system.vue'
import ordinary_user_system from './views/ordinary_user_system.vue'
import vip_privilege_system from './views/vip_components/vip_privilege_system.vue'
import vip_recharge_system from './views/vip_components/vip_recharge_system.vue'
import vip_points_system from './views/vip_components/vip_points_system.vue'
import service_system from './views/service_system.vue'
import device_system from './views/device_system.vue'
import work_order_system from './views/work_order_system.vue'
import VueRouter from 'vue-router'
import { Message } from "element-ui";
import axios from 'axios'


Vue.use(Router)
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const router = new Router({
  mode: "history",
  routes: [
    {
      path:'/login',
      component:login,
      name:'login'
    },
    { path: '/', 
      component: Home,
      redirect: 'main',
      children: [
        {
          path: 'main',
          name: '首页',
          component: main
        },
        {
          path: 'shop_list',
          name: '店铺列表',
          component: page1
        },
        {
          path: 'room_list',
          name: '包间列表',
          component: page2
        },
        {
          path: 'deploy_play',
          name: '玩法配置',
          component: deploy_play
        },
        {
          path: 'user_personal',
          name: '个人中心',
          component: user_personal
        },
        {
          path: 'user_system',
          name: '角色管理',
          component: user_system
        },
        {
          path: 'department_system',
          name: '部门管理',
          component: department_system
        },
        {
          path: 'job_system',
          name: '岗位管理',
          component: job_system
        },
        {
          path: 'banner_system',
          name: 'banner管理',
          component: banner_system
        },
        {
          path: 'order_system',
          name: '订单管理',
          component: order_system
        },
        {
          path: 'activity_system',
          name: '活动管理',
          component: activity_system
        },
        {
          path: 'coupon_system',
          name: '优惠券管理',
          component: coupon_system
        },
        {
          path: 'coupon_type_system',
          name: '优惠券类型管理',
          component: coupon_type_system
        },
        {
          path: 'feedback_system',
          name: '意见反馈',
          component: feedback_system
        },
        {
          path: 'settled_system',
          name: '加盟管理',
          component: settled_system
        },
        {
          path: 'faq_system',
          name: '常见问题',
          component: faq_system
        },
        {
          path: 'message_system',
          name: '消息管理',
          component: message_system
        },
        {
          path: 'ordinary_user_system',
          name: '普通用户管理',
          component: ordinary_user_system
        },
        {
          path: 'vip_privilege_system',
          name: '会员特权管理',
          component: vip_privilege_system
        },
        {
          path: 'vip_recharge_system',
          name: '会员充值管理',
          component: vip_recharge_system
        },
        {
          path: 'vip_points_system',
          name: '会员积分管理',
          component: vip_points_system
        },
        {
          path: 'service_system',
          name: '客服管理',
          component: service_system
        },
        {
          path: 'device_system',
          name: '设备管理',
          component: device_system
        },
        {
          path: 'work_order_system',
          name: '工单管理',
          component: work_order_system
        }
      ]
    }
  ]
})

//挂载路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next();
  //获取token
  const s_token = window.sessionStorage.getItem('token')
  if (!s_token){
    Message({
      showClose: true,
      message: '登录过期,请重新登录',
      type: 'warning',
      center: true,
      offset: 100
    });
    return next('/login')
  }else{
    
    const s_tokens = window.sessionStorage.getItem('token')
    let d_data = {
      'token': s_tokens
    }
    console.log(s_tokens)

    // 刷新token
    axios.post(
      '/api/refresh_token/', d_data, {headers: {
      "Content-Type": "application/json"
    }}).then(function(res){
      window.sessionStorage.setItem("token", res.data.token);
    }).catch(function (error) {
      console.log(error);
      Message({
        showClose: true,
        message: '刷新token失败,请重新登录',
        type: 'warning',
        center: true,
        offset: 100
      });
      return next('/login')
    })

    next()
  }
  
})

export default router